var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@web/components/layout/Button';
import Loading from '@web/components/layout/Loading';
import Checkbox from '@web/components/ui/Form/Checkbox';
import { OpenInNewTabIcon } from '@web/components/ui/icons/OpenInNewTabIcon';
import { trpc } from '@web/lib/trpc';
import { getDriveLinkByType, getIconByType } from '@web/utility';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
var DocAlertsConfigListNew = function (_a) {
    var _b, _c;
    var selectedDocuments = _a.selectedDocuments, setSelectedDocuments = _a.setSelectedDocuments, search = _a.search;
    var t = useTranslation().t;
    var documents = trpc.documents.useQuery({
        limit: 50,
        notIds: selectedDocuments,
        search: search
    });
    var _d = useState(), newSelectedDocuments = _d[0], setNewSelectedDocuments = _d[1];
    return (_jsxs("div", __assign({ className: "mt-3" }, { children: [_jsx("ul", __assign({ className: "divide-y divide-gray-100 max-h-[220px] overflow-y-auto" }, { children: (_b = documents.data) === null || _b === void 0 ? void 0 : _b.map(function (document) { return (_jsx("li", __assign({ className: "flex items-center justify-between gap-x-3 py-3" }, { children: _jsx("div", __assign({ className: "min-w-0 flex-1 text-gray-500" }, { children: _jsx(Checkbox, { label: _jsxs("div", __assign({ className: "flex min-w-0 items-center gap-1" }, { children: [_jsx("span", __assign({ className: "shrink-0" }, { children: getIconByType(document.type, {
                                            width: '16',
                                            height: '16'
                                        }) })), _jsx("span", __assign({ className: "truncate" }, { children: document.title })), _jsx(Link, __assign({ to: getDriveLinkByType(document.type, document.slugId), target: "_blank", rel: "noopener noreferrer", onClick: function (e) { return e.stopPropagation(); }, className: "shrink-0 text-indigo-600 hover:text-indigo-800", "aria-label": t('docAlerts.modal.openDocument') }, { children: _jsx(OpenInNewTabIcon, { width: "16", height: "16" }) }))] })), name: "documents", value: document.id, checked: newSelectedDocuments === null || newSelectedDocuments === void 0 ? void 0 : newSelectedDocuments.includes(document.id), onChange: function (e) {
                                var value = parseInt(e.target.value);
                                if (newSelectedDocuments === null || newSelectedDocuments === void 0 ? void 0 : newSelectedDocuments.includes(value)) {
                                    setNewSelectedDocuments(newSelectedDocuments.filter(function (id) { return id !== value; }));
                                }
                                else {
                                    setNewSelectedDocuments(__spreadArray(__spreadArray([], (newSelectedDocuments !== null && newSelectedDocuments !== void 0 ? newSelectedDocuments : []), true), [
                                        value
                                    ], false));
                                }
                            } }) })) }), document.id)); }) })), _jsxs("div", __assign({ className: "flex min-h-12 mt-3" }, { children: [_jsx("div", __assign({ className: "w-[95px]" }, { children: _jsx(Button, __assign({ variant: "white", disabled: !(newSelectedDocuments === null || newSelectedDocuments === void 0 ? void 0 : newSelectedDocuments.length), onClick: function () {
                                setSelectedDocuments(__spreadArray(__spreadArray([], selectedDocuments, true), (newSelectedDocuments !== null && newSelectedDocuments !== void 0 ? newSelectedDocuments : []), true));
                                setNewSelectedDocuments([]);
                            } }, { children: t('docAlerts.modal.add', {
                                count: (_c = newSelectedDocuments === null || newSelectedDocuments === void 0 ? void 0 : newSelectedDocuments.length) !== null && _c !== void 0 ? _c : 0
                            }) })) })), documents.isLoading && (_jsx(Loading, { className: "h-auto pr-16", spinnerClassName: "h-6 w-6" }))] }))] })));
};
export default DocAlertsConfigListNew;
